import ReviewList from "common/pages/Review/ReviewList";
import _ from "lodash";
import React from "react";


const DoctorReviewList = ({ doctorInfo }) => {
    return (
        <ReviewList filterParams={{ doctorId: doctorInfo.id }} />
    )
}

export default DoctorReviewList;
